import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./OurWork.css";
import LeafletMap from "../../../Utils/LeafletMap";

// Improved Swipers component with better height management
const Swipers = ({
  slidesData,
  renderSlide,
  slidesPerView = 1,
  spaceBetween = 30,
  loop = false,
  autoplay = false,
  navigation = false,
  pagination = false,
  onSwiper
}) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    // Update swiper on window resize
    const handleResize = () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Swiper
      ref={swiperRef}
      modules={[Navigation, Pagination]}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      loop={loop}
      autoplay={autoplay ? { delay: 5000, disableOnInteraction: false } : false}
      navigation={navigation}
      pagination={pagination ? { clickable: true } : false}
      onSwiper={onSwiper}
      className="our-work-swiper"
    >
      {slidesData &&
        slidesData.map((slide, index) => (
          <SwiperSlide key={slide.id || index}>
            {renderSlide(slide)}
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

const OurWork = ({ onMapClick }) => {
  // const [activeTab, setActiveTab] = useState(donationData[0]?.id || '');
  // const [activeSlides, setActiveSlides] = useState(donationData);
  const swiperRef = useRef(null);
  const [mapType, setMapType] = useState("heatmap");
  const [baseMapType, setBaseMapType] = useState("map");
  const [masterData, setMasterData] = useState([]);
  const defaultMapCenter = [22.9734, 78.6569]; // India center
  const defaultZoom = 5;

  const mapTypes = {
    heatmap: "heatmap_style",
    choropleth: "choropleth_style",
    points: "point_style",
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('StateMaster'));
    if (data) {
      setMasterData(data);
    }
  }, [])
  // Filter slides when tab changes
  // useEffect(() => {
  //   // Show all slides but put the active one first
  //   const activeItem = donationData.find(item => item.id === activeTab);
  //   if (activeItem) {
  //     const filteredData = [
  //       activeItem,
  //       ...donationData.filter(item => item.id !== activeTab)
  //     ];
  //     setActiveSlides(filteredData);
  //   }
  // }, [activeTab, donationData]);

  const handleTabClick = (tabId) => {
    // setActiveTab(tabId);
    if (swiperRef.current) {
      swiperRef.current.slideTo(0);
    }
  };

  const renderDonationItem = (item) => (
    <div className="donation-list-four__item">
      <div className="donation-list-four__thumb">
        {/* <img src={item.imageSrc} alt={item.subtitle} /> */}
        {/* <LeafletMap
        /> */}
      </div>
      <div className="donation-list-four__content">
        <div className="donation-list-four__content__top">
          <h3 className="donation-list-four__title">{item.title}</h3>
          <h4>{item.subtitle}</h4>
          <p className="donation-list-four__text">
            {item.text.length > 250 ? `${item.text.substring(0, 250)}...` : item.text}
          </p>
        </div>
        <div className="text-end"> <a href={item.readMoreLink} className="acwadam-btn acwadam-btn--base">
          Read More
        </a></div>
      </div>
    </div>
  );

  // Swiper parameters
  const swiperParams = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: false,
    pagination: true,
    onSwiper: (swiper) => {
      swiperRef.current = swiper;
    }
  };

  const handleFeatureClick = (data, type) => {
    onMapClick(data, type); // Forward data + type to HomePage
  };

  return (
    <section className="donation-list-four">
      <div className="container-fluid">
        <div className="donation-list-four__inner">
          <div className="tab-box-buttons">
            <div className="tab-buttons">
              {/* {donationData.map((item) => (
                <button
                  key={item.id}
                  data-tab={`#${item.id}`}
                  className={`acwadam-btn tab-btn mx-2 ${activeTab === item.id ? 'active-btn' : ''}`}
                  onClick={() => handleTabClick(item.id)}
                >
                  {item.subtitle}
                </button>
              ))} */}
            </div>
          </div>

          <div className="tabs-content">
            {/* <Swipers
              {...swiperParams}
              slidesData={activeSlides}
              renderSlide={renderDonationItem}
            /> */}
            <div>
              {(masterData && Object.keys(masterData).length > 0) && <LeafletMap masterData={masterData} onFeatureClick={handleFeatureClick} />}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// const OurWork = () => {
//   const tabs = [
//     {
//       id: 'action-research',
//       title: 'Our Work',
//       subtitle: 'Action Research',
//       text: "ACWADAM's action research has spanned two decades now. Moreover, its action research is backed by more than 35 years of conventional academic research by its founder trustees. The focus of this research is groundwater management. The action research has included scientific aspects of developing implementable plans for groundwater management, without overemphasising the need to publish research in a classically academic mode. The conventional over-emphasis on scientific precision in aquifer...",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [28.6139, 77.2090],
//         name: 'Delhi Project',
//         projectId: '1',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [19.0760, 72.8777],
//         name: 'Mumbai Project',
//         projectId: '2',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }, {
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: '3',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: '4',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//     {
//       id: 'capacity-building',
//       title: 'Our Work',
//       subtitle: 'Capacity Building',
//       text: "This is the content for Capacity Building. ACWADAM focuses on building the capacity of various stakeholders in groundwater management through training programs, workshops, and knowledge sharing initiatives.",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: 'abc1-001',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: 'abc2-002',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//     {
//       id: 'facilitation',
//       title: 'Our Work',
//       subtitle: 'Facilitation',
//       text: "Content for Facilitation goes here. ACWADAM plays a crucial role in facilitating dialogues and collaborations among different communities and organizations involved in groundwater resource management.",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: 'abc1-001',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: 'abc2-002',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//     {
//       id: 'workshop-conference',
//       title: 'Our Work',
//       subtitle: 'Workshop & Conference',
//       text: "Details about Workshops & Conferences organized by ACWADAM. These events serve as platforms for knowledge exchange and networking in the field of groundwater management.",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: 'abc1-001',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: 'abc2-002',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//     {
//       id: 'internships',
//       title: 'Our Work',
//       subtitle: 'Internships',
//       text: "Information about Internship opportunities at ACWADAM. We provide valuable learning experiences for individuals interested in pursuing a career in groundwater management and research.",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: 'abc1-001',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: 'abc2-002',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//     {
//       id: 'customizations',
//       title: 'Our Work',
//       subtitle: 'Customizations',
//       text: "Learn about our Customization services in groundwater management. We offer tailored solutions to meet the specific needs of communities and organizations.",
//       imageSrc: '/assets/ourWorkImg/indiaMap-Inner.png',
//       readMoreLink: '#',
//       data: [{
//         coords: [29.6139, 75.2090],
//         name: 'abc1 Project',
//         projectId: 'abc1-001',
//         description: 'Groundwater recharge initiative in Delhi.',
//         status: 'active'
//       },
//       {
//         coords: [20.0760, 73.8777],
//         name: 'abc2 Project',
//         projectId: 'abc2-002',
//         description: 'Urban aquifer mapping project in Mumbai.',
//         status: 'inactive'
//       }]
//     },
//   ];

//   return <DonationListFour donationData={tabs} />;
// };

export default OurWork;